import { motion } from 'framer-motion';

const variants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.22, ease: 'easeOut' } },
    exit:    { opacity: 0, y: -10, transition: { duration: 0.18, ease: 'easeIn' } },
};

export default function PageTransition({ children, keyId }) {
    return (
        <motion.main
            className="page container route-page"
            key={keyId}
            variants={variants}
            initial="initial"   // входная анимация включена
            animate="animate"
            exit="exit"
        >
            {children}
        </motion.main>
    );
}
